import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import type { AuraVisualizationPlan } from '@/types';
import { formatAuraDateLabel, formatAuraMetric } from '@/utils/auraPresentation';
import AuraChartBlock from './AuraChartBlock.vue';

interface Props {
    plan: AuraVisualizationPlan;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraVisualizationPanel',
  props: {
    plan: { type: Object, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;
const selectedLabel = ref<string | null>(null);

const primaryChart = computed(() => props.plan.charts[0]);
const selectedIndex = computed(() => {
    if (!selectedLabel.value || !primaryChart.value?.labels) return -1;
    return primaryChart.value.labels.indexOf(selectedLabel.value);
});

const selectedDetails = computed(() => {
    const index = selectedIndex.value;
    const chart = primaryChart.value;
    if (!chart || index < 0) return null;

    const series = (chart.series || [])
        .map((item) => ({
            name: item.name,
            value: Number(item.data[index] || 0),
        }))
        .filter((item) => item.value > 0);

    return {
        label: selectedLabel.value,
        value: Number(chart.data[index] || 0),
        unit: chart.unit || '',
        series,
    };
});

const handleSelect = (params: unknown) => {
    if (!params || typeof params !== 'object' || !('name' in params)) return;
    const name = String((params as { name?: unknown }).name || '');
    selectedLabel.value = name || null;
};

const __returned__ = { props, selectedLabel, primaryChart, selectedIndex, selectedDetails, handleSelect, get formatAuraDateLabel() { return formatAuraDateLabel }, get formatAuraMetric() { return formatAuraMetric }, AuraChartBlock }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})